module.exports = __webpack_public_path__ + "static/media/testimony1.3fd89c0b.png";